var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcPasswordMark = function SvgIcPasswordMark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    transform: "translate(-1 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(1 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M1.818,15.333H18.182V17H1.818Zm.941-3.375.7-1.233.7,1.233,1.064-.625-.7-1.233H5.909V8.85H4.518l.7-1.225L4.15,7l-.7,1.225L2.759,7,1.7,7.625l.7,1.225H1V10.1H2.391l-.7,1.233Zm5.482-.625,1.064.625.7-1.233.7,1.233,1.064-.625-.7-1.233h1.391V8.85H11.064l.7-1.225L10.7,7,10,8.225,9.3,7l-1.064.625.7,1.225H7.545V10.1H8.936ZM19,8.85H17.609l.7-1.225L17.241,7l-.7,1.225L15.85,7l-1.064.625.7,1.225H14.091V10.1h1.391l-.7,1.233,1.064.625.7-1.233.7,1.233,1.064-.625-.7-1.233H19Z",
    transform: "translate(-1 -7)",
    fill: "#25556e"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcPasswordMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_password_mark.506bc4e8404643bd5891ab84c92502b5.svg";